module.exports = __webpack_public_path__ + "img/UNIBUD-W-TRANSPARENT.2fb0fb24.svg";